import { lazy } from 'react';

const MyAccount = lazy(() => import('../pages/customer/MyAccount.jsx'));
const Profile = lazy(() => import('../pages/customer/Profile.jsx'));
const MyOrders = lazy(() => import('../pages/customer/MyOrders.jsx'));
const OrderDetails = lazy(() => import('../pages/customer/OrderDetails.jsx'));
const MyInquiries = lazy(() => import('../pages/customer/MyInquiries.jsx'));
const InquiryDetails = lazy(() => import('../pages/customer/InquiryDetails.jsx'));
const Wishlist = lazy(() => import('../pages/customer/Wishlist.jsx'));
const Compare = lazy(() => import('../pages/customer/Compare.jsx'));
const AddressBook = lazy(() => import('../pages/customer/AddressBook.jsx'));
const ChangePassword = lazy(() => import('../pages/customer/ChangePassword.jsx'));

const customerRoutes = [
  { path: '', Component: MyAccount },
  { path: 'profile', Component: Profile },
  { path: 'orders', Component: MyOrders },
  { path: 'orders/:id', Component: OrderDetails },
  { path: 'inquiries', Component: MyInquiries },
  { path: 'inquiries/:id', Component: InquiryDetails },
  { path: 'wishlist', Component: Wishlist },
  { path: 'compare', Component: Compare },
  { path: 'addresses', Component: AddressBook },
  { path: 'change-password', Component: ChangePassword },
];

export default customerRoutes;
